const MODEL_NAME = 'hostingpage'
export default [
  {
    path: `/${MODEL_NAME}/service`,
    name: 'servicePage',
    component: () =>
      import(/* webpackChunkName: "hostingpage-sservice" */ '@pages/hostingPage/service.vue')
  },
  {
    path: `/${MODEL_NAME}/machine`,
    name: 'machine',
    component: () =>
      import(/* webpackChunkName: "hostingpage-machine" */ '@pages/hostingPage/machine.vue')
  }
]
